import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/Clubs/ReadingClub/2024/ReadingDay/1.jpg';

// import p1 from 'assests/Photos/Clubs/ReadingClub/2024/ReadingDay/1.jpg';

// import p2 from 'assests/Photos/Clubs/ReadingClub/2024/ReadingDay/2.jpg';
// import p3 from 'assests/Photos/Clubs/ReadingClub/2024/ReadingDay/3.jpg';
// import p4 from 'assests/Photos/Clubs/ReadingClub/2024/ReadingDay/4.jpg';

// import p5 from 'assests/Photos/SchoolProgram/2023/RepublicDay/5.jpg';
// import p6 from 'assests/Photos/SchoolProgram/2023/RepublicDay/6.jpg';
// import p7 from 'assests/Photos/SchoolProgram/2023/RepublicDay/7.jpg';
// import p8 from 'assests/Photos/SchoolProgram/2023/RepublicDay/8.jpg';
// import p9 from 'assests/Photos/SchoolProgram/2023/RepublicDay/9.jpg';
// import p10 from 'assests/Photos/SchoolProgram/2023/RepublicDay/10.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2024 from '../ReadingClub/components/Sidebar2024';
import Archive2024 from '../ReadingClubSidebar2025/Archive2024';
import ReadingClubSidebar2026 from '../ReadingClubSidebar2026';

const ReadingDay2026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    

    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
      fetch('/config.json')
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2026}/home/events-activities/club/ReadingClub/ReadingDay/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/club/ReadingClub/ReadingDay/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/club/ReadingClub/ReadingDay/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/club/ReadingClub/ReadingDay/4.webp`;
    

    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
      
        
      
       
    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                READING DAY	
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                               Date: 22 June 2026
                                </Typography>

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                    The Department of Library, National Public School, Yeshwanthpur, celebrated Reading Day on Monday, 22 June 2026, to commemorate the death anniversary of Late Shri P. N. Panicker, widely regarded as the ‘Father of the Library Movement’ in India. 
                                                    <br></br>
                        As a part of the morning assembly, two students of Class 5 and one student of Class 10, spoke about the
                        significance of reading and its role in shaping knowledge, creativity, and lifelong learning. A Reading
                        Pledge was also administered to inspire students to develop and nurture the habit of reading. The students
                        of Class 4 participated in the D.E.A.R. (Drop Everything and Read) activity wherein they enthusiastically
                         gathered to read books provided by the school
                        library and creatively formed the word ‘LIBRARY’, thus making the event both engaging and meaningful. 
                                                                                    <br></br>
                        Addressing the gathering, the Vice Principal highlighted the importance of cultivating a regular reading habit.
                        She encouraged students to dedicate a part of
                        their daily routine to reading, emphasizing that books are a gateway to knowledge, imagination, and personal growth.
                                                                                    <br></br>
                        DEAR is more than just reading, it is a celebration of literature, a daily dose of inspiration and a commitment to lifelong learning.
                                                                                    <br></br>

                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “The more that you read, the more things you will know. The more that you learn, the more places you'll go”-Dr Seuss

                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <ReadingClubSidebar2026/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2024/>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default ReadingDay2026;